const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/33540390f643937a387ee69ee6db3814/2107f49c7f66e26bc31712c9355e7f9a.jpeg"
                alt="Pablo Conejero - Cirugía Veterinaria"
                className="w-48 h-auto object-contain"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              <strong>Cirujano veterinario especializado</strong> en Almería con más de 25 años de experiencia en traumatología, oncología y neurocirugía.
            </p>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/#inicio" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Inicio
                </a>
              </li>
              <li>
                <a href="/#servicios" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Servicios
                </a>
              </li>
              <li>
                <a href="/casos-clinicos" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Casos Clínicos
                </a>
              </li>
              <li>
                <a href="/zonas-servicio" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Zonas de Servicio
                </a>
              </li>
              <li>
                <a href="/#contacto" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Especialidades</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/cirugia-veterinaria-almeria"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  <strong>Cirugía Veterinaria Almería</strong>
                </a>
              </li>
              <li>
                <a
                  href="/traumatologo-veterinario-almeria"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  <strong>Traumatólogo Veterinario</strong>
                </a>
              </li>
              <li>
                <a
                  href="/traumatologo-veterinario-almeria"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  <strong>Cirugía TPLO</strong>
                </a>
              </li>
              <li>
                <a
                  href="/cirugia-oncologica-veterinaria-almeria"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  <strong>Cirugía Oncológica</strong>
                </a>
              </li>
              <li className="text-gray-300 text-sm">
                <strong>Neurocirugía Veterinaria</strong>
              </li>
              <li className="text-gray-300 text-sm">
                <strong>Cirugía Torácica</strong>
              </li>
            </ul>
          </div>

          {/* Contact Info & Service Areas */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-teal-400"></i>
                </div>
                <span className="text-gray-300 text-sm ml-3">
                  <strong>Almería y provincia</strong>
                </span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-teal-400"></i>
                </div>
                <a
                  href="https://wa.me/34600581975"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm ml-3 cursor-pointer"
                >
                  +34 600 581 975 (WhatsApp)
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-teal-400"></i>
                </div>
                <a
                  href="mailto:vetconejero@gmail.com"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm ml-3 cursor-pointer"
                >
                  vetconejero@gmail.com
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="font-semibold text-sm mb-3">Sígueme</h4>
              <div className="flex space-x-3">
                <a
                  href="https://www.linkedin.com/in/pabloconejero/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-700 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a
                  href="https://www.instagram.com/vetconejero/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-700 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a
                  href="https://share.google/P15uGxF2dVhsVwi2u"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-700 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                  aria-label="Google Business Profile"
                >
                  <i className="ri-google-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Service Areas Section */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <h4 className="font-semibold text-lg mb-4 text-center">
            <a href="/zonas-de-servicio" className="hover:text-teal-400 transition-colors cursor-pointer">
              Zonas de Servicio - Cirugía Veterinaria
            </a>
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 text-center">
            <a href="/zonas-de-servicio#almeria" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Almería</strong>
            </a>
            <a href="/zonas-de-servicio#roquetas-de-mar" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Roquetas de Mar</strong>
            </a>
            <a href="/zonas-de-servicio#el-ejido" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>El Ejido</strong>
            </a>
            <a href="/zonas-de-servicio#nijar" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Níjar</strong>
            </a>
            <a href="/zonas-de-servicio#vicar" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Vícar</strong>
            </a>
            <a href="/zonas-de-servicio#adra" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Adra</strong>
            </a>
            <a href="/zonas-de-servicio#huercal-overa" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Huércal-Overa</strong>
            </a>
            <a href="/zonas-de-servicio#vera" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Vera</strong>
            </a>
            <a href="/zonas-de-servicio#huercal-de-almeria" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Huércal de Almería</strong>
            </a>
            <a href="/zonas-de-servicio#cuevas-del-almanzora" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Cuevas del Almanzora</strong>
            </a>
            <a href="/zonas-de-servicio#berja" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Berja</strong>
            </a>
            <a href="/zonas-de-servicio#albox" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Albox</strong>
            </a>
            <a href="/zonas-de-servicio#pulpi" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Pulpí</strong>
            </a>
            <a href="/zonas-de-servicio#garrucha" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Garrucha</strong>
            </a>
            <a href="/zonas-de-servicio#aguadulce" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Aguadulce</strong>
            </a>
            <a href="/zonas-de-servicio#carboneras" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Carboneras</strong>
            </a>
            <a href="/zonas-de-servicio#granada" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Granada</strong>
            </a>
            <a href="/zonas-de-servicio#motril" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Motril</strong>
            </a>
            <a href="/zonas-de-servicio#baza" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Baza</strong>
            </a>
            <a href="/zonas-de-servicio#murcia" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Murcia</strong>
            </a>
            <a href="/zonas-de-servicio#lorca" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Lorca</strong>
            </a>
            <a href="/zonas-de-servicio#aguilas" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Águilas</strong>
            </a>
            <a href="/zonas-de-servicio#jaen" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Jaén</strong>
            </a>
            <a href="/zonas-de-servicio#malaga" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Málaga</strong>
            </a>
            <a href="/zonas-de-servicio#torre-del-mar" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Torre del Mar</strong>
            </a>
            <a href="/zonas-de-servicio#velez-malaga" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Vélez-Málaga</strong>
            </a>
            <a href="/zonas-de-servicio#rincon-de-la-victoria" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Rincón de la Victoria</strong>
            </a>
            <a href="/zonas-de-servicio#nerja" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Nerja</strong>
            </a>
            <a href="/zonas-de-servicio#torrox" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
              <strong>Torrox</strong>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Pablo Conejero - <strong>Cirugía Veterinaria Almería</strong>. Todos los derechos reservados.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
